"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstructionOverviewOptions = void 0;
var getInstructionOverviewOptions = exports.getInstructionOverviewOptions = {
  name: 'instruction',
  options: function options(_ref) {
    var store = _ref.store;
    var router = store.router,
      platform = store.platform;
    var _router$params = router.params,
      guideSlug = _router$params.guideSlug,
      topicSlug = _router$params.topicSlug,
      instructionSlug = _router$params.instructionSlug;
    return {
      variables: {
        slug: instructionSlug,
        topicSlug: topicSlug,
        guideSlug: guideSlug,
        locale: platform.getLanguage()
      }
    };
  }
};
//# sourceMappingURL=query-options.js.map